import Joi from '@hapi/joi'

export const FactoryWeightDetailsReportObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name characters`
    }),
    factoryID: Joi.number().invalid(0).required().label("Route Name").messages({
        "any.invalid": `Factory Name cannot have invalid characters`,
        "any.required": `Factory Name Type characters`
    }),
    routeID: Joi.number().label("Route").optional().allow(0),
    searchdate: Joi.string().invalid("").label("Search Date"),
    toDate: Joi.string().invalid("").label("Search Date"),
    collectionTypeID: Joi.number().label("Route Name").messages({
        "any.invalid": `Factory Name cannot have invalid characters`
    }),
}